import { Chip } from "@components/ui/Chip"
import { useTFFLocationsByState } from "@features/tff/useTFFLocations"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "TFF Full Schedule",
  icon: "location",
  tags: ["#homepage"],
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("tff-center/tff-full-schedule", (props) => {
  const locations = useTFFLocationsByState()

  return (
    <div className="my-10">
      <div className="grid-auto">
        <div className="col-span-12 mb-7 sm:col-span-4 md:col-span-6">
          <EditableText store="label" as="h3" className="type-title-m" defaultValue="Full Schedule" />
        </div>
        <div className="col-span-12 sm:col-span-8 md:col-span-6 flex flex-col gap-8">
          {locations.map((state) => {
            return (
              <div key={state.state}>
                <h4 className="type-title-s mb-3">{state.stateLabel}</h4>
                <div className="flex flex-col group">
                  {state.locations.map((location) => (
                    <Link
                      href={location.uri}
                      className="flex gap-grid-gutter type-label-m border-b border-bg-mid py-3 hover:!opacity-100 group-has-[a:hover]:opacity-80 transition-opacity"
                      key={location.uri}
                    >
                      <div className="text-fg md:w-cols-2">{location.title}</div>
                      <div className="flex-none">
                        {location.status.saleStatusLabel && (
                          <Chip shape="rounded" variant={location.status.onSale ? "hero" : "mid"}>
                            {location.status.saleStatusLabel}
                          </Chip>
                        )}
                      </div>
                      <div
                        className={cn(
                          "text-right flex-1",
                          location.centerInfo?.showFestivalDates ? "text-fg" : "text-fg-secondary",
                        )}
                      >
                        {location.status.datesText}
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
})
